import { isAfter, isBefore, isToday, parseISO } from 'date-fns';
import { useMemo } from 'react';
export const useHotlineInformation = ({
  openingHours,
  specials
}) => {
  const now = new Date();
  const special = specials?.find(({
    publishDate,
    expiryDate
  }) => isBefore(now, expiryDate) && isAfter(now, publishDate));
  const todaySpecial = special?.items.find(element => isToday(parseISO(element.date)));
  const {
    from = openingHours?.from || '09:00:00',
    to = openingHours?.to || '22:00:00',
    icon
  } = todaySpecial || {};
  return useMemo(() => ({
    short: {
      from: from.replaceAll(/^0|:00/g, ''),
      to: to.replaceAll(/^0|:00/g, '')
    },
    long: {
      from: from.slice(0, 5),
      to: to.slice(0, 5)
    },
    todaySpecial,
    icon,
    teaserSpecialImage: special?.image,
    specialHeadline: special?.text
  }), [from, to]);
};